import { render, staticRenderFns } from "./orderdetails-component.vue?vue&type=template&id=186e231e"
import script from "./orderdetails-component.vue?vue&type=script&lang=ts"
export * from "./orderdetails-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports